export const TOP_AREA_BANNER_DIALOG = 'top-area-banner-dialog';
export const TOP_AREA_BANNER_DIALOG_GREETING_MESSAGE = 'top-area-banner-dialog-greeting-message';
export const TOP_AREA_BANNER_DIALOG_MESSAGE = 'top-area-banner-dialog-message';
